import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Divider } from '@chakra-ui/react';
import invariant from 'tiny-invariant';

import { MainPageContent } from '../../../common/components';
import { PendingReturnItemsTable } from './components/PendingReturnItemsTable/PendingReturnItemsTable';
import { TwoFactorReturnSettings } from './components/TwoFactorReturnSettings/TwoFactorReturnSettings';

export const TwoFactorReturn = () => {
  const { restaurantId } = useParams<{ restaurantId: string }>();
  invariant(restaurantId, 'restaurantId is not set within the route');

  return (
    <MainPageContent>
      <Box pb={6}>
        <TwoFactorReturnSettings restaurantId={restaurantId} />
      </Box>
      <Divider />
      <Box pt={6}>
        <PendingReturnItemsTable restaurantId={restaurantId} />
      </Box>
    </MainPageContent>
  );
};
